import Drag from '../../drag'

export default class ImgDrag extends Drag {
  useType = 'make';
  rightKeyMenu = null;
  blockInfo = {
    uuid: '',
    x: 80,
    y: 80,
    width: 80,
    height: 80,
    leftBottomCoordinate: {
      x: 160,
      y: 160
    },
    image: '',
    opaqueBottom: true, // 不透明底： true， 透明底： false
    mislead: false, // 误导标记 true: 误导， false: 正确答案
  };

  /**
   * 
   *   @param {String} plate: 区域類名(.question-design) || body
   *   @param {String} useType: 使用類型。 value: ['make', 'view']. 默认 ‘make’
   *   @param {Object} blockStyle 
   *    style: 方块样式,
   *    selectStyle: 方块选中样式
   *   @param {number | string} maxNum: 允许最多方块 默认10
   */
  constructor(obj) {
    super(obj)

    this.useType = obj.useType || this.useType
    
    this.init()
  }

  init() {
    this.customRightKeyMenu()
    
    // 只有make 才能调用
    this.useType == 'make' && this.findscroller()
  }

  // 调用基類 创建方块
  handleCreateBlock() {
    this.createBlock(node => {
      node.addEventListener('contextmenu', ev => {
        ev.preventDefault()

        let { rightKeyMenu, curBlock } = this
        rightKeyMenu.style.display = 'block'
        rightKeyMenu.style.left = `${ev.pageX}px`
        rightKeyMenu.style.top = `${ev.pageY}px`
        rightKeyMenu.focus()
        
        for(let i = 0; i < rightKeyMenu.childNodes.length; i++) {
          let item = rightKeyMenu.childNodes[i]

          if([...item.classList].indexOf('mislead-choice') > -1) {
            item.innerText = curBlock.mislead ? '取消误导选项' : '设为误导选项'
          }
          if([...item.classList].indexOf('opaque-bottom') > -1) {
            item.innerText = curBlock.opaqueBottom ? '设置为透明底层' : '设置为不透明底层' 
            break ;
          }
        }
      })
    })
  }

  /**
   * 右键自定义菜单
   */
  customRightKeyMenu() {
    let menu = document.createElement('div')
    menu.setAttribute('class', 'right-key-menu')
    menu.setAttribute('tabindex', '0')
    let singleMenu = [
      {text: '複製', class: 'copy'},
      {text: '上传圖片', class: 'update-image'},
      {text: '误导选项', class: 'mislead-choice'},
      {text: '设置为透明底层', class: 'opaque-bottom'},
      {text: '删除', class: 'remove-block'}
    ]

    // 追加子节点
    while(menu.childNodes.length < singleMenu.length) {
      let child = document.createElement('div'),
      item = singleMenu[menu.childNodes.length]
      child.setAttribute('class', `menu-single ${item.class}`)
      child.innerText = item.text

      // 每个按钮增加事件
      if(menu.childNodes.length == 0) child.addEventListener('click', copyBlock)
      if(menu.childNodes.length == 1) child.addEventListener('click', updateImg)
      if(menu.childNodes.length == 2) child.addEventListener('click', misleadChoice)
      if(menu.childNodes.length == 3) child.addEventListener('click', setOpaqueBottom)
      else if(menu.childNodes.length == 4) child.addEventListener('click', removeBlock)

      menu.append(child)
    }

    menu.style.display = 'none'
    document.body.append(menu)
    this.rightKeyMenu = menu

    // 添加失去焦点事件
    menu.addEventListener('blur', () => {
      menu.style.display = 'none'
    })

    //  -------- 子节点事件函數 --------
    let that = this

    // 复制块元素
    function copyBlock() {
      // console.log('copyBlock')
    }

    // 上传圖片
    function updateImg() {
      let fileDom = document.createElement('input')
      fileDom.type = 'file'
      fileDom.onchange = () => {
        let files = fileDom.files[0],
        formData = new FormData();
        formData.append('file', files);

        // 临时圖片
        let node = document.querySelector(`#${that.curBlock.uuid}`)
        that.curBlock.image = URL.createObjectURL(files)
        node.style.backgroundImage = `url(${that.curBlock.image})`
        node.classList.remove('error-block-style')

        // file('https://math-concept-dev.liangzhicn.com/portal/api/v1/files', formData)
        //   .then(res => {
        //     console.log(res)
        //   })
        // 重置
        fileDom.value = ''
        that.fn(that.blockMap)
      }

      fileDom.click()
    }

    // 误导选项
    function misleadChoice () {
      let { curBlock } = that
      curBlock.mislead = !curBlock.mislead

      that.rightKeyMenu.blur()
      that.fn(that.blockMap)
    }

    // 切换透明底层
    function setOpaqueBottom() {
      // 设置为透明底层
      let { curBlock: { uuid }, curBlock } = that,
      node = document.querySelector(`#${uuid}`),
      bgcolor = 'rgba(0, 0, 0, 0)'

      // 处理數据
      curBlock.opaqueBottom = !curBlock.opaqueBottom
      if(curBlock.opaqueBottom) bgcolor = '#ccc'

      // 样式修改
      node.style.backgroundColor = bgcolor
      that.rightKeyMenu.blur()

      that.fn(that.blockMap)
    }

    // 移除方块
    function removeBlock() {
      let { uuid } = that.curBlock,
      { plate } = that,
      removeNode = document.querySelector(`#${uuid}`)

      plate.removeChild(removeNode)
      that.blockMap.delete(uuid)
      that.curBlock = {}
      that.rightKeyMenu.blur()

      that.fn(that.blockMap)
    }
  }

  /**
   * 回显视图
   * @param {Array} map 
   */
  echoBlock(map, vue) {
    let { plate, plateObj: { plateClass } } = this, i = 0,
    blockList = document.querySelectorAll(`${plateClass} .block-style`), j = 0,
    status = ['success', 'error'], k;
    
    // 清空
    while(j < blockList.length) {
      plate.removeChild(blockList[j])
      j ++;
    }

    // 追加
    for(;i < map.length; i++) {
      let {width, height, x, y, uuid, opaqueBottom, mislead} = map[i],
      block = document.createElement('div')
      
      console.log(mislead, i)
      // 误导方块 直接跳过 执行下一轮循环
      if(!mislead) continue;

      block.setAttribute('class', 'block-style')
      block.setAttribute('id', uuid)
      block.style = `
        width: ${width}px;
        height: ${height}px;
        top: ${y}px;
        left: ${x}px;
      `
      block.style.backgroundColor = opaqueBottom ? '#ccc' : 'rgba(0, 0, 0, 0)'
      block.dataset.subscript = i
      block.dataset.mark = -1
     
      // 追加状态节点
      k = 0
      while(k < status.length) {
        let statusNode = document.createElement('div')
        statusNode.setAttribute('class', status[k])

        block.append(statusNode)
        k ++;
      }

      plate.append(block)

      // 添加拖动事件
      this.insertEvent(block, map, vue)
    }
  }

  /**
   * 回显方块 添加事件
   * @param {node} node 
   */
  insertEvent(node, map, vue) {
    let { existImage } = vue
    node.ondragover = ev => {
      ev.stopPropagation()
      ev.preventDefault()
    }

    node.ondrop = ev => {
      let mark = ev.dataTransfer.getData('info')
      , subscript = node.dataset.subscript

      // 当前 block 是否存在mark标记
      if(node.dataset.mark != -1) {
        // 消除标记
        existImage.splice(existImage.indexOf(node.dataset.mark), 1)
      }

      // 标记
      node.dataset.mark = mark
      existImage.push(Number(mark))

      // 更新视图
      node.style.backgroundImage = `url(${map[mark].image})`
      if(map[subscript].image == map[mark].image) {
        node.querySelector('.success').style.display = 'block'
        node.querySelector('.error').style.display = 'none'
      } else {
        node.querySelector('.success').style.display = 'none'
        node.querySelector('.error').style.display = 'block'
      }
    }

    // 移除已有的圖片
    node.onclick = () => {
      let mark = Number(node.dataset.mark)
      
      if(mark != -1) {
        // 更新视图
        node.querySelector('.success').style.display = 'none'
        node.querySelector('.error').style.display = 'none'

        node.style.backgroundImage = `url()`
        node.dataset.mark = -1

        existImage.splice(existImage.indexOf(mark), 1)
      }
    }
  }
}